import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, getDeviceId } from '@/utils/auth'
import { getTimeOffset } from '@/utils'
import NProgress from 'nprogress';
import Vue from 'vue'

const _axios = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api 
  //timeout: 5000,
})
_axios.defaults.headers.common['client-id'] = process.env.VUE_APP_CLIENT_ID;
_axios.defaults.headers.common['device-id'] = getDeviceId();
_axios.defaults.headers.common['time-offset'] = getTimeOffset();

_axios.defaults.headers.common['Accept'] = 'application/json, text/plain, */*';


_axios.interceptors.request.use(
  config => {
    NProgress.start();
    const authToken = getToken();
    if(authToken){
      config.headers['Authorization'] =  'Bearer '+authToken;
    }

    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

_axios.interceptors.response.use(
  response => {
    NProgress.done();
    
    return response.data
  },
  error => {
    
    NProgress.done();
    if(error.response.status === 500) {

      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    else if(error.response.status === 403) {
      Message({
        message: 'You do not have the authority.',
        type: 'error',
        duration: 5 * 1000
      })
    }


    return Promise.reject(error)
  }
)

let Plugin = {};

Plugin.install = function (Vue, options) {
    Vue.axios = _axios
    window.axios = _axios
    Object.defineProperties(Vue.prototype, {
        axios: {
            get() {
                return _axios
            }
        },
        $axios: {
            get() {
                return _axios
            }
        }
    })
}

Vue.use(Plugin)

export default Plugin

